import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-574cba32"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode("这是一个亮晶晶的按钮");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createBlock(_component_el_button, {
    color: "#1890ff",
    style: {
      "color": "white"
    },
    class: "kilakila-button"
  }, {
    default: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "default", {}, function () {
        return [_hoisted_1];
      }, true)];
    }),
    _: 3
  });
}